module.exports = __webpack_public_path__ + "static/img/logo96.e87a5c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo96.png
// module id = ocl5
// module chunks = 1